
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class ClassifyCar extends Component {

    handleChangeClassifyCar = (value) => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { value, disabled, typeOption } = this.props;
        return (
            <div className="vat-fee">
                <Checkbox disabled={disabled} onChange={() => this.handleChangeClassifyCar('MT')} checked={value === 'MT'}>MT</Checkbox>
                <Checkbox disabled={disabled} onChange={() => this.handleChangeClassifyCar('AT')} checked={value === 'AT'}>AT</Checkbox>
            </div>
        )
    }
}